import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import LoginMenuContainer from './containers/LoginMenuContainer';

const rootElement = document.querySelector('.app-mitstudie-container');
 
const root = createRoot(rootElement!);
root.render(
  <StrictMode>
    <LoginMenuContainer />
  </StrictMode>,
);
